import { Link } from 'react-router-dom'
// Shared layout wrapper used by all pages
export function PageShell({ title, subtitle, children }) {
  return (
    <div style={{ minHeight: '100vh', background: '#080808', fontFamily: "'Montserrat', sans-serif", paddingBottom: '60px' }}>
      <div style={{ padding: '20px 24px', display: 'flex', alignItems: 'center', gap: '14px', borderBottom: '1px solid #1a1a1a' }}>
        <Link to="/" style={{ background: 'transparent', border: '1px solid #1a1a1a', color: '#666', padding: '6px 12px', borderRadius: '6px', textDecoration: 'none', fontSize: '12px' }}>← SYNINN</Link>
        <div>
          <div style={{ fontFamily: 'serif', fontSize: '20px', fontWeight: '300', color: '#fff', letterSpacing: '2px' }}>{title}</div>
          {subtitle && <div style={{ fontSize: '10px', color: '#555', marginTop: '1px' }}>{subtitle}</div>}
        </div>
      </div>
      <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
        {children}
        <div style={{ marginTop: '32px', padding: '14px 16px', background: '#111', border: '1px solid #1a1a1a', borderRadius: '10px', textAlign: 'center', fontSize: '11px', color: '#333' }}>
          SYNINN · syninn.com · A product of Shashank Yash Technologies
        </div>
      </div>
    </div>
  )
}

// Shared section renderer used by policy pages
export function PolicyPage({ title, subtitle, sections }) {
  return (
    <PageShell title={title} subtitle={subtitle}>
      {sections.map((section, i) => (
        <div key={i} style={{ marginBottom: '24px' }}>
          {section.heading && <div style={{ fontSize: '11px', color: '#C9A84C', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '10px', fontWeight: '600' }}>{section.heading}</div>}
          {section.text && <div style={{ fontSize: '13px', color: '#888', lineHeight: '1.8' }}>{section.text}</div>}
          {section.items && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {section.items.map((item, j) => (
                <div key={j} style={{ padding: '12px 16px', background: '#111', border: '1px solid #1a1a1a', borderRadius: '10px', fontSize: '13px', color: '#888', lineHeight: '1.7' }}>{item}</div>
              ))}
            </div>
          )}
        </div>
      ))}
    </PageShell>
  )
}